export enum GroupType {

     CUS_GROUP_CHECK_STATE         = 1, //查看客户群组权限
     ALIAS_GROUP_STATE             = 5, //客户别名群组
     GROUP_BRANCH_ORDER            = 13, //查看分支报修单权限群组
     GROUP_DEPARTMENT_CHECK        = 14, //部门审核群组
     GROUP_CHECK                   = 15, //分组审核群组

    //推单群组
     CUS_GROUP_PUSH_STATE          = 0, //客户推单群组
    //group_cs中的2或者3对应group_push中的3，group_push中无2只有3
     GROUP_PUSH_AREA               = 2, //省市区地址推单群组
     GROUP_PUSH_ADDRESS_CUSTOM     = 3, //自定义
     GROUP_PUSH_FAULT              = 4, //故障现象推单群组
     GROUP_PUSH_TAGS               = 6, //标签推单群组
     GROUP_PUSH_COMBINATION        = 7, //组合推单群组
     GROUP_PUSH_DEPARTMENT         = 9,//报修部门推单群组

     GROUP_VIEW_DEPARTMENT_PART    = 20, // 查看备件群组

}